/* 
	File name		: Contact.js
	Purpose			: Corresponds to the Contact page of the application.
	Developed by	: Aarthi Meena T, Sowbhagya Lakshmi H T, Yogeshwari V S
	Last updated on	: 20-05-2023
	Last updated by	: Yogeshwari V S
*/

import React from 'react'
import Navbar from '../../Components/js/Navbar';

function Contact() {
	return (
		<div>
			<Navbar />

			<center>
				<h3>For any queries, write to us via</h3> <h2>paraescapade.yas@gmail.com</h2>
			</center>
		
		</div>
	)
}

export default Contact
